<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/MasterProductUnitPrice'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              ตั้งค่าราคาค่าถัง
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm"> 
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ชื่อสินค้า :</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'MbSKUId'"
                    :name="'MbSKUId'"
                    :multiple="true"
                    :select2-options="MbSKUOptions"
                    v-model="MbSKUId"
                    ref="MbSKUSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="MbSKUId"
                    :multiple="true"
                    :options="MbSKUOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ปี(สินค้า) (ค.ศ.) :</label>
                 
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(YYYY)"
                      id="odYear"
                      name="odYear"
                      ref="odYear"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div> 

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'odInActiveStatus'"
                    :name="'odInActiveStatus'"
                    :select2-options="odInActiveStatusOptions"
                    v-model="odInActiveStatus"
                    ref="odInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>

            </div>
 
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="MasterProductUnitPrice/Add"
                  tag="button"
                  title="เพิ่มข้อมูลการสั่งซื้อ "
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูล
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="BarcodeAlertConfigTable"
              >
                <thead>
                  <tr>
                    <th class="all" width="8%">รายการที่</th> 
                    <th class="all center">ชื่อสินค้า</th>
                    <th class="all center">เจ้าของทรัพย์สิน</th>
                    <th class="all">ปี(สินค้า)</th>
                    <th class="all">ราคา</th> 
                    <th class="all center" width="10%">วันที่บันทึก</th>
                    <!-- <th class="all center" width="10%">วันที่มีผล สิ้นสุด</th> -->
                    <th width="10%" class="center">สถานะ</th> 
                    <th width="15%" class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import axios from "axios";
import datepicker from "../../../Shared/Datepicker";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
 

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      console.log(this.data);
      let self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          }); 

          axios
            .put("/Api/MasterProductUnitPrice/" + this.data.id + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    savedata : function(){
      axios
            .put("/Api/MasterProductUnitPrice/" +  this.data.id  + "/Toggle")
            .then(function(response) {  
              if (response.data.data) { 
                $("#BarcodeAlertConfigTable") .DataTable() .ajax.reload(null, false); 
                //   self.$parent.reloadDataTable(); 
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              console.log(error);
              //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
    },
    editStatus: function() {
      let self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          }); 

          axios
          .post("/Api/MasterProductUnitPrice/ValidateDate", {  
            Id:this.data.id, 
            odMaterialCode:this.data.materialcode, 
            mbAssetOwnerId : this.data.assetOwnerId,
            odYear: this.data.year ,  

            })
            .then(function(response) {
              console.log(response.data);
              if(response.data != null && response.data != ""){ 
                // มีข้อมูลอยู่แล้ว
                console.log(response);
                var product = response.data.materialcode + " "+ response.data.materialdesC_TH2 ;
                Swal.fire({
                  title: "แจ้งเตือน",
                  html: "ปี : " + response.data.year +"<br> สินค้า : " +product + "<br> เจ้าของทรัพย์สิน :" +response.data.assetOwnerName + " <br> มีการกำหนดราคาไว้แล้วคือราคา "+response.data.unitPrice +" ",
                  icon: "warning",
                  showCancelButton: true,
                  showConfirmButton: false,
                  //confirmButtonColor: "#3085d6",
                  //cancelButtonColor: "#d33",
                 // confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                }).then((result) => { 
                  if (result.value) {
                     self.savedata();
                  } 
                });

              }
              else{ 
                 self.savedata();
              }
              //console.log(response);
            })
            .catch(function(error) {
              console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", "ERR", "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            }); 

          
        }
      });
    },
  },
});
let Action = Vue.extend({
  template: `
  <div> 
    <a href="#" @click.prevent="editData" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteData" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    detailData: function() {
      router.push({
        path: `/Master/MasterProductUnitPrice/Detail/${this.data.id}`,
      });
    },
    editData: function() {
      router.push({
        path: `/Master/MasterProductUnitPrice/Edit/${this.data.id}`,
      });
    },
    deleteData: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูล",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูล <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ลบข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/MasterProductUnitPrice/" + this.data.id + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;

    
    return {
      odInActiveStatus: null,
      orlKeyword: null, 
      MbSKUOptions: [],
      MbSKUId: [],
      odYear:null,// moment() ,
      odInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null }
        ]
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this; 
      this.MbSKUId = [];
      this.odYear = null;
      this.odInActiveStatus = null;
      $("#odInActiveStatus")
        .val(this.pbInActiveStatus + "")
        .trigger("change");

      $("#odYear").val("").trigger("change");
      // $(function(){
      //   self.odYear = moment().year();  
      //   $("#odYear").val(moment().year()).trigger("change"); 
      // });
 
      self.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#BarcodeAlertConfigTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) { 
      $("#BarcodeAlertConfigTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadMbSKUTransTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterOverdueSetting/Select2BarcodeAlertTransType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbSKUTransTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadMbSKUOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbSKUOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;
    self.LoadMbSKUOptions(); 
   //self.LoadMbSKUTransTypeOptions(); 
    // $(function(){
    //   self.odYear = moment() ;  
    //   $("#odYear").val(moment().year()).trigger("change"); 
    // });
    $(`#odInActiveStatus`).val("false").trigger('change');


    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    } 
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#BarcodeAlertConfigTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/MasterProductUnitPrice/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //check for clear date value
            var idDate = $("#orlInvDate").val();
            if (idDate == null || idDate == "") self.orlInvDate = null;
            
            

            let jsonSearch = {
              InActiveStatus: self.odInActiveStatus,
              SearchKeyword: self.orlKeyword, 
              ProductCodes: self.MbSKUId ,
              //TransTypes: self.MbSKUTransTypeId  ,
              odYear: self.odYear != null
                ? self.odYear.format("YYYY")
                : self.odYear,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        }, 
        // Order settings
        order: [[0, "asc"]],
        columns: [
         // { data: "rowNum", className: "text-center" },
          {
            data: "rowNum",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          }, 
          {
            data: "materialcode",
            className: "text-center",
            render: function (data, type, full, meta) {
              return full.materialcode + "-" + full.materialdesC_TH2;
            },
          }, 
          { data: "assetOwnerName", className: "text-center" },
          { data: "year", className: "text-center" },
          { data: "unitPrice", className: "text-center" },
          
          {
            data: "effectiveDateStart",
            className: "text-center",
            render: function(data, type, full, meta) {
              return moment(data).format("DD/MM/YYYY")  ;
            },
          },
          // {
          //   data: "effectiveDateEnd",
          //   className: "text-center",
          //   render: function(data, type, full, meta) {
          //     return moment(data).format("DD/MM/YYYY")  ;
          //   },
          // },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          // {
          //   data: "inActiveStatus",
          //   className: "text-center",
          //   width: "10%",
          //   orderable: false,
          //   render: function(data, type, full, meta) {
              
          //     if(data)
          //       return '<div class="actionsStatus">Inactive</div>';
          //     else
          //     return '<div class="actionsStatus">Active</div>';
          //   },
          // },
          
          {
            data: "id",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        alert(message)
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([ "MANAGE_MASTER", "MANAGE_ALERT"]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER", "MANAGE_ALERT",
            ]);
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_ALERT",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_ALERT",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row

    $(self.$refs.odYear).datepicker({
      format: "yyyy",
      viewMode: "years",
      minViewMode: "years",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.odYear).datepicker(
      "update",
      !!self.odYear ? self.odYear.format("YYYY") : null
    ).on("changeDate", function(e) {
      self.odYear = e.dates.length != 0 ? moment(e.date) : null;
    });

  },

  
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/MasterProductUnitPrice/MasterProductUnitPriceList.vue